<template>
    <div :data-uuid="settings.uuid" :style="containerStyle" v-if="isVisible()">
        <input name="payment_type" type="text" :value="payment_type" v-if="payment_type" hidden />
        <input name="merchant_setting_id" type="text" :value="merchant_setting_id" v-if="merchant_setting_id" hidden />
        <component :is="'style'">
            {{ commonStyle }}
        </component>
        <div :key="payment.id" v-for="payment in data.type_partial_payment">
            <div @mousedown.stop.prevent="handlePayment" :data-payment="payment.id" :style="paymentStyle">
                <div
                    :class="{ 'widget-radio-input_active': payment.id == payment_type }"
                    class="widget-radio-input"
                ></div>

                {{ payment.title }}
            </div>
            <div
                style="margin-bottom: 10px"
                v-if="
                    payment.id == payment_type &&
                    (payment_type === 'equal_parts' || payment_type === 'specified_schedule')
                "
            >
                <div
                    class="partial"
                    :class="{ partial_active: schedule.is_active || index === 0 }"
                    :key="schedule.id"
                    v-for="(schedule, index) in data.schedules.find(schedule => schedule.id === payment_type).items"
                    v-html="schedule.text || createText(schedule)"
                ></div>
            </div>
        </div>

        <div
            :class="{
                'merchants-container':
                    data.merchant_settings &&
                    !data.merchant_settings.find(merchant_setting => merchant_setting.description)
            }"
            v-if="data.merchant_settings_count > 1"
        >
            <div v-for="merchant_setting in data.merchant_settings" :key="merchant_setting.id">
                <div
                    @mousedown="handleMerchant"
                    style="cursor: pointer"
                    :data-merchant="merchant_setting.id"
                    class="merchant-link"
                    :class="{ 'merchant-link_active': merchant_setting.id == merchant_setting_id }"
                >
                    <img
                        style="max-height: 45px; pointer-events: none; max-width: 90%"
                        :src="merchant_setting.merchant.logo"
                        :alt="merchant_setting.merchant.name"
                    />
                </div>
                <p v-if="merchant_setting.description" class="text">
                    {{ merchant_setting.description.text }}
                </p>
            </div>
        </div>

        <WidgetField :settings="fieldSettings" v-if="data.coupons_type && data.coupons_type.id !== 1" />
    </div>
</template>

<script>
import ViewMixin from "../utils/view-mixin"
import { allEvents, resolveFont, resolveMargin } from "../utils/style"
import WidgetField from "./WidgetField.vue"
import cloneDeep from "lodash.clonedeep"
import { FIELD } from "../../../../../modules/Expert/views/CTA/settings/cta-settings"

const commonStyle = `
.widget-radio-input {
    margin-right: 14px;
    width: 16px;
    height: 16px;
    position: relative;
    border-radius: 50%;
    border: 1px solid #DDDDDD;
    box-sizing: content-box !important;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
}

.widget-radio-input::after {
    content: '';
    display: block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #DDDDDD;
}
.widget-radio-input_active {
    border-color: #15A06E !important;
}
.widget-radio-input_active::after {
    background: #15A06E !important;
}
.merchants-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, 160px);
    grid-gap: 10px 30px;
    justify-content: center;
}
.merchant-link {
    width: 160px;
    height: 56px;
    box-shadow: 0 4px 10px rgba(128, 158, 191, 0.15);
    border-radius: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    transition: 0.2s;
}
.merchant-link_active {
    border-color: #3965FF;
    background: #F2F7FF;
}
.partial {
    width: fit-content;
    padding: 5px 15px;
    font-weight: 400;
    font-size: 13px;
    line-height: 130%;
    border-radius: 4px;
    color: #52565C;
    border: 1px solid transparent;
    margin-left: 30px;
}
.partial_active {
    background: #F1F8FC;
    border-color: #B3DBF1;
}
.text {
    margin-top: 5px;
    margin-bottom: 10px;
    line-height: 17px;
    font-size: 13px;
}
`

export default {
    components: { WidgetField },
    props: {
        settings: {
            type: Object,
            default: () => {}
        },
        parent: {
            type: Object,
            default: () => {}
        }
    },
    mixins: [ViewMixin],
    name: "WidgetRadioFormGroup",
    data() {
        return {
            payment_type: null,
            merchant_setting_id: null
        }
    },
    created() {
        if (!this.settings.general.promoCode) {
            const promoCode = cloneDeep({
                ...FIELD,
                general: {
                    ...FIELD.general,
                    placeholder: this?.t("payments.enter_promo_code") || "Promocode"
                }
            })

            this.settings.general = {
                ...this.settings.general,
                promoCode
            }
        }
    },
    computed: {
        fieldSettings() {
            const code = this.settings?.general?.promoCode || FIELD
            return {
                uuid: `coupon-${Date.now()}`,
                type: "FIELD",
                name: "Field",
                ...code
            }
        },
        payload() {
            return this.parent.general.payload
        },
        desktop() {
            return this.settings.desktop
        },
        mobile() {
            return this.settings.mobile
        },
        general() {
            return this.settings.general
        },
        data() {
            return this.payload.offer_data
        },
        paymentStyle() {
            return {
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                marginBottom: "10px"
            }
        },
        commonStyle() {
            return commonStyle
        },
        containerStyle() {
            return {
                width: "100%",
                ...allEvents(),
                ...this.resolveStyle(
                    {
                        ...resolveFont(this.desktop.font),
                        ...resolveMargin(this.desktop.margin)
                    },
                    {
                        ...resolveFont(this.mobile.font),
                        ...resolveMargin(this.mobile.margin)
                    }
                )
            }
        }
    },
    methods: {
        createText(schedule) {
            return `${schedule.payment_at}: <b>${schedule.price}</b>`
        },
        handlePayment(event) {
            this.payment_type = event.target.dataset.payment
        },
        handleMerchant(event) {
            this.merchant_setting_id = event.target.dataset.merchant
        },
        isVisible() {
            const isVisible =
                this.parent &&
                this.payload.id === 2 &&
                ((this.isCanPaymentProcessing() && this.isInternalProcessing()) ||
                    (this.data && this.data.coupons_type && this.data.coupons_type.id !== 1)) &&
                this.payload.offer_data &&
                !this.payload.has_full_access_to_product

            if (isVisible && this.payload.offer_data) {
                if (!this.payment_type && this.payload.offer_data.type_partial_payment) {
                    this.payment_type = this.payload.offer_data.type_partial_payment[0].id
                }
                if (
                    !this.merchant_setting_id &&
                    this.payload.offer_data.merchant_settings &&
                    this.payload.offer_data.merchant_settings[0]
                ) {
                    this.merchant_setting_id = this.payload.offer_data.merchant_settings[0].id
                }
            }

            return isVisible
        },
        isInternalProcessing() {
            return this.payload.processing_type && this.payload.processing_type.value === "internal"
        },
        isCanPaymentProcessing() {
            if (this.payload.offers && this.payload.offers.length) {
                const [offer] = this.payload.offers
                return !offer.is_free && (offer.merchant_settings_count > 1 || offer.payment_type.id === 2)
            } else {
                return false
            }
        }
    },
    watch: {
        parent: {
            deep: true,
            handler() {
                this.$forceUpdate()
            }
        }
    }
}
</script>
